import { render, staticRenderFns } from "./CpuTab.vue?vue&type=template&id=146df251&scoped=true&"
import script from "./CpuTab.vue?vue&type=script&lang=ts&"
export * from "./CpuTab.vue?vue&type=script&lang=ts&"
import style0 from "./CpuTab.vue?vue&type=style&index=0&id=146df251&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146df251",
  null
  
)

export default component.exports